import React from 'react'
import "./skills.scss"

export default function Skills() {
  return (
    <div className="skills" id="skills">
      <div className="wrapper">
        <h1><strong>function myRelevant<wbr/>Skills<wbr/>() &#123;</strong></h1>
        <h2>
        👨‍💻 Programming 👨‍💻 = [ Java, HTML/CSS, Python, C, JavaScript, SQL, ARM assembly, TypeScript ];<br/><br/>
        💻 Technologies 💻 = [ React, Git, GitHub, Bootstrap, Node.js, Emacs, Flask, NumPy, Matplotlib ];<br/><br/>
        🖌 Design 🖌 = [ Adobe Photoshop, Adobe Illustrator, Adobe InDesign, Figma, Procreate ];<br/><br/>
        
        </h2>
        <h1><strong>&#125;</strong></h1>
      </div>
    </div>
  )
}
